import React, {memo} from "react";
import TransactionLink from "../../../../TransactionLink";

function Number(props) {
    const { record } = props;

    return (
        <div className="BaseTable__row-cell-text">
            <TransactionLink transaction={record} label={record.number} />
        </div>
    );
}

export default memo(Number);
